import './secondaryFooter.scss'
import { IconButton } from '@common/components/iconButton/IconButton'
import { DisplayText } from '@/cms/components/displayText'
import Divider from '@/content/components/divider/Divider'
import type { SecondaryFooterPropsApi } from '@/content/sections/secondaryFooter/models'

export const SecondaryFooter = (props: SecondaryFooterPropsApi) => {
    const {
        appInformationTitle,
        appInformationDescription,
        appAppleStoreLink,
        appGooglePlayStoreLink,
        thirdColumnTitle,
        thirdColumnLinks,
        fourthColumnTitle,
        fourthColumnLinks,
    } = props

    return (
        <>
            <div className="secondary-footer container-lg-padding">
                <div className="secondary-footer__app-details">
                    <p className="secondary-footer__app-details__title">{appInformationTitle}</p>
                    <p className="secondary-footer__app-details__description">{appInformationDescription}</p>
                    <div className="secondary-footer__app-details__app-icons">
                        {appAppleStoreLink && (
                            <IconButton iconName="AppleAppStore" className="apple" href={appAppleStoreLink} />
                        )}
                        {appGooglePlayStoreLink && (
                            <IconButton iconName="GooglePlayStore" className="google" href={appGooglePlayStoreLink} />
                        )}
                    </div>
                </div>
                <div className="secondary-footer__services__booking">
                    <p className="secondary-footer__services__booking__title">{thirdColumnTitle}</p>
                    {thirdColumnLinks && <DisplayText label={thirdColumnLinks} />}
                </div>
                <div className="secondary-footer__services__customer">
                    <p className="secondary-footer__services__customer__title">{fourthColumnTitle}</p>
                    {fourthColumnLinks && <DisplayText label={fourthColumnLinks} />}
                </div>
            </div>
            <Divider />
        </>
    )
}
